<template>
  <div>
    <Multiselect
      :id="htmlId"
      v-model="valueHandler"
      :max="numOfItems"
      label="value"
      trackBy="key"
      valueByPath="key"
      :options="options"
      :disabled="visibility > 0"
    >
    </Multiselect>
  </div>
</template>

<script>
import _ from 'lodash'
import DataTypeMixin from 'CORE/mixins/dataType'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import { createDataTypeValue } from '../utils'

export default {
    name: 'EnumInput',
    components: {
        Multiselect,
    },
    mixins: [
        DataTypeMixin,
    ],
    props: {
        value: {
            required: false,
            type: Object,
            default: _ => createDataTypeValue(),
        },
    },
    data() {
        return {
            data: '',
        }
    },
    computed: {
        valueHandler: {
            get() {
                return _.get(this.value, 'value.value', null)
            },
            set(value) {
                if (_.size(value) === 0) {
                    this.$emit('delete')
                } else {
                    if (this.visibility === 0) {
                        this.$emit('input', createDataTypeValue(value))
                    }
                }
            },
        },
        options() {
            return _.map(_.get(this.propertyType, 'settings.enum.list'), e => {
                return {
                    key: e.text,
                    value: e.text,
                }
            })
        },
        numOfItems() {
            return _.toInteger(_.get(this.propertyType, 'multiple', -1))
        },
    },
}
</script>
